import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  card: {
    marginTop: "6px",
    marginLeft: "15px",
    borderLeft: `1px solid ${theme.palette.grey[300]}`,
  },
  container: {
    padding: "8px 14px",
    marginTop: "4px",
    borderTop: "1px solid #f0f0f0",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "12px",
  },
  header: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
  label: {
    fontSize: "9px",
    fontWeight: 600,
    color: "#999",
    textTransform: "uppercase",
    letterSpacing: "0.2px",
  },
  value: {
    fontSize: "16px",
    fontWeight: 700,
    color: "#333",
    lineHeight: 1,
    marginLeft: "4px",
  },
  small_damaged_icon: {
    fontSize: "12px",
    color: "#d32f2f",
  },
  actions: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    gap: "2px",
  },
  action_link: {
    fontSize: "12px",
  },
}));

export default useStyles;
